import { makeAutoObservable } from "mobx";
import { IStudentTask, TaskStatus } from "../../models/student";
import { CompletedTicketService } from "../../services/completed-ticket-service";
import { message } from "antd";

export default class StudentTaskStore {

    data: IStudentTask;
    isSaved: boolean | undefined;
    completedTaskService: CompletedTicketService;

    constructor(data: IStudentTask) {

        this.data = data;
        this.isSaved = undefined;
        this.completedTaskService = new CompletedTicketService();

        makeAutoObservable(this);
    }

    changeTaskState(value: string) {

        this.isSaved = false;
        this.data.status = TaskStatus[value as keyof typeof TaskStatus];

        switch (this.data.status) {

            case TaskStatus.NOT_DONE: {
                this.data.studentAnswer = "";
                this.data.studentPoints = 0;
                break;
            }
            case TaskStatus.SUCCESS: {

                if (this.isTestTask() && this.data.taskAnswer) {
                    this.data.studentAnswer = this.data.taskAnswer;
                }

                this.data.studentPoints = this.data.taskPoints;
                break;
            }
            case TaskStatus.ERROR: {
                this.data.studentAnswer = "";
                this.data.studentPoints = 0;
                break;
            }
        }
    }

    isTestTask(): boolean {
        return this.data.taskPoints === 1;
    }

    changeStudentAnswer(value: string) {

        if (this.data.studentAnswer !== value.trim()) {
            this.isSaved = false;
        }

        this.data.studentAnswer = value.trim();

        if (this.data.taskAnswer) {

            this.data.status = this.data.studentAnswer === this.data.taskAnswer ? TaskStatus.SUCCESS : TaskStatus.ERROR;

            if (this.data.taskPoints === 1) {
                this.data.studentPoints = this.data.status === TaskStatus.SUCCESS ? 1 : 0;
            }
        }
    }

    changeStudentPoint(value: number | null) {

        if (value) {

            if (this.data.studentPoints !== value) {
                this.isSaved = false;
            }

            this.data.studentPoints = value;
            this.data.status = TaskStatus.SUCCESS;
        } else {
            this.data.status = TaskStatus.ERROR;
        }
    }

    saveResult() {

        this.completedTaskService.saveTasks([this.data], () => {
            message.success("Успешно сохранено!");
            this.isSaved = true;
        });
    }
}